
import styled, { css } from "styled-components";
import { InputComponent } from "../common/InputComponent";
import CustomButton from "../common/customButton";
import { useEffect, useState } from "react";
import CloseIcon from "../icon/closeIcon";
import AdminCreatePopUpModal from "./adminCreatePopupModal";

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2); /* 배경을 약간 어둡게 만듭니다. */
  z-index: 9998; /* 모달보다 아래에 위치하도록 설정합니다. */
`;

const Wrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50vw;
  height: 68vw;
  background-color: white;
  border-radius: 0.8vw;
`;

const ModalWrapper = styled.div`
  width: 84%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ModalTopArea = styled.div`
  margin-top: 1vw;
  width: 100%;
  height: 5vw;
  display: flex;
  justify-content: end;
  align-items: center;
`;

const DateWrapper = styled.div`
  width: 100%;
  height: 51vw;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
`;

const CloseBtnBox = styled.div`
  width: 5vw;
  height: 5vw;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1vw;
  background-color: #8080802f;
`;

const BtnBox = styled.div`
  margin-top: 1vw;
  margin-bottom: 3vw;
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* outline: 1px solid red; */
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
const BoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 90%;
  height: 100%;
  padding-top: 2vw;
`;

const UpperBox = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 20%;
`;
export default function AdminCreatePopUpModalComponent(props: any) {
    const [popupModalVisible, setPopupModalVisible] = useState<boolean | null>(
        false
    );

    //----- 모달 핸들러
    const popupModalHandle = () => {
        setPopupModalVisible(true)
    }

    const onClose = () => {
        setPopupModalVisible(false)
    }


    return (
        <>
            {popupModalVisible &&
                <AdminCreatePopUpModal
                    onClose={onClose}
                />
            }
            <Container>
                <BoxWrapper>
                    <CustomButton onClick={popupModalHandle} width={'20vw'}
                        size={'2vw'} height={'5vw'} text="공지사항 추가"></CustomButton>
                </BoxWrapper>
            </Container>
        </>
    )
}
